import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import {
  Grid,
  Paper,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import DateFnsUtils from "@date-io/date-fns";
import Moment from "moment";
import { extendMoment } from "moment-range";
import { useLocation } from 'react-router-dom';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import LeaveService from "../../../services/LeaveService";
import DayService from "../../../services/DayService";
import { userDetailContext } from "../../../App";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { hasPrivilege } from "../../../utils/privilege";
import Message from "../../tools/Message";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import { headerDataRH } from "../../../data/modules/hr-header";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import ConfirmationDialog from "../../tools/ConfirmationDialog";
import MotifAnnulationLeave from "../../tools/MotifAnnulationLeave";
import { CircularProgress } from "@material-ui/core";
import UserService from "../../../services/UserService";

const bullRed = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '5px', transform: 'scale(0.8)', color: 'red', fontSize: '20px' }}
  >
    *
  </Box>
)

const moment = extendMoment(Moment);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "row",
    width: "90%",
    maxWidth: "90%",
    margin: "0 auto",
    elevation: 0,
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  disabledSolde: {
    background: "rgb(235, 235, 228)",
    cursor: "default",
    pointerEvents: "none !important",
  },
  text: {
    fontSize: "16px",
    fontWeight: "bold",
  },
}));

function LeaveStagiaire(props) {
  const [beginDate, setBeginDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [radioBeginDate, setRadioBeginDate] = useState(null);
  const [radioEndDate, setRadioEndDate] = useState(null);
  const [motif, setMotif] = useState("");
  const [delta, setDelta] = useState();
  const [askedDayOff, setAskedDayOff] = useState(0);
  const [dayOffType, setDayOffType] = useState("");
  const [leave_type, setLeaveType] = useState([]);
  const [day, setDay] = useState([]);
  const [valid, setValid] = useState(false);
  const [validdebut, setValiddebut] = useState(false);
  const [beginDateNotMatch, setBeginDateNotMatch] = useState(false);
  const [dateBeginFormatNotMatch, setDateBeginFormatNotMatch] = useState(false);
  const [dateEndFormatNotMatch, setDateEndFormatNotMatch] = useState(false);
  const [dateBeginInDayNotCounted, setDateBeginInDayNotCounted] = useState(false);
  const [dateEndinDayNotCounted, setDateEndinDayNotCounted] = useState(false);
  const [realdelta, setRealdelta] = useState(0);
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [leaveValide, setLeaveValide] = useState(0);
  const [idLeave, setIdLeave] = useState(0);

  const [isRealBalanceAlreadyConfigurate, setisRealBalanceAlreadyConfigurate] = useState(false);
  const [errorMessageForRealBalanceEmpty, seterrorMessageForRealBalanceEmpty] = useState("");

  const [isLeaveUpdated, setLeaveUpdated] = useState(false);
  const [isConfirmationFinal, setIsConfirmationFinal] = useState(false);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const contextData = useContext(userDetailContext);
  const navigate = useNavigate();
  const params = useParams();
  const [pendingleave, setPendingleave] = useState(0);

  const [confirmationDialog, setConfirmationDialog] = useState({
    openDialog: false,
    messageDialog: "Voulez vous vraiment annuler votre demande de congé  ?",
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [isCancel, setIsCancel] = useState(false);
  const [openDialogueerreur, setOpenDialogueerreur] = useState(false);
  const [openDialoguejoursmax, setOpenDialoguejourmax] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [emptyMotif, setEmptyMotif] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [raison, setRaison] = useState('');
  const [codeobselete, setCodeobselete] = useState('');
  const [codeLeave, setCodeLeave] = useState('');
  const [fileObselete, setFileObselete] = useState('');
  const [fileRequest, setFileRequest] = useState('');

  const [isValidEdited, setIsValidEdited] = useState(false);
  const [confirmLeaveAdd, setConfirmLeaveAdd] = useState(false);

  const [loadingPlanning, setloadingPlanning] = useState(false);
  const [loadingValidate, setloadingValidate] = useState(false);
  const [isLeavePlanningUpdated, setisLeavePlanningUpdated] = useState(false);
  const [idLeavePlanningUpdated, setidLeavePlanningUpdated] = useState(false);

  const [isValidatorNumberConfigurate, setisValidatorNumberConfigurate] = useState(false);
  const [dayOffNumberWithoutValidation, setdayOffNumberWithoutValidation] = useState(false);

  function getDayLeave(beginDate, endDate) {
    var dateArray = [];
    var currentDate = moment(beginDate);
    var stopDate = moment(endDate);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
      currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }

  function getDayParameter(beginDate, endDate) {
    let count = 0;
    const tab = getDayLeave(beginDate, endDate);
    for (let j = 0; j < day.length; j++) {
      for (let i = 0; i < tab.length; i++) {
        if (day[j] == tab[i]) {
          count++;
        }
      }
    }
    return count;
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const idLeaveToUpdated = params.id ? params.id : "";
  const valide = params.valide;
  const idLeaveToValidate = params.idLeaveToValidate;

  function handleChangeLeave(isRealRequest = null) {
    setLoading(true);
    LeaveService.saveLeave(
      1,
      beginDate,
      radioBeginDate,
      endDate,
      radioEndDate,
      false,
      delta,
      0,
      askedDayOff,
      "Fraction de congé",
      0,
      isValidEdited,
      null,
      idLeave,
      isRealRequest,
      isLeavePlanningUpdated,
      isValidatorNumberConfigurate,
      dayOffNumberWithoutValidation
    )
      .then((res) => {
        if (res && res.status === 200) {
          setMessage({ ...message, open: true, color: 'green', messageInfo: "Succès" });
          setLoading(false);
          setloadingPlanning(false);
          setloadingValidate(false);
          navigate("/leavestglist");
        } else {
          setLoading(false);
          setloadingPlanning(false);
          setloadingValidate(false);
          setMessage({ ...message, open: true, color: 'red', messageInfo: res.message || "Erreur undefined" });
        }
      })
      .catch((err) => {
        setLoading(false);
        setloadingPlanning(false);
        setloadingValidate(false);
        setMessage({ ...message, open: true, color: 'red', messageInfo: "Une erreur s'est produite. Veuillez réessayer" });
      });
  }

  function Daynumber(beginDate, endDate, radioBeginDate, radioEndDate) {
    if (beginDate !== undefined && endDate !== undefined && beginDate !== "" && endDate !== "") {
      LeaveService.getLeaveDay(beginDate, endDate).then((result) => {
        if (result && result.data !== undefined) {
          let daysOff = result.data; 
  
          const countDay = getDayParameter(beginDate, endDate);
          if (countDay != null) {
            daysOff = daysOff - countDay; 
          }
  
          if (radioBeginDate === "afternoon") {
            daysOff -= 0.5;
          }
          if (radioEndDate === "afternoon") {
            daysOff += 0.5;
          }
  
          setAskedDayOff(daysOff);
        } else {
          setAskedDayOff(0); 
        }
      }).catch((error) => {
        setAskedDayOff(0); 
      });
    } else {
      setAskedDayOff(0); 
    }
  }

  const handleClose = () => {
    setOpenDialogueerreur(false);
  };

  const handleCloseJourmax = () => {
    setOpenDialoguejourmax(false);
  };

  function handleClick() {
    if (parseInt(askedDayOff,10) < 0) {
       setMessage({ ...message, open: true, color: 'red', messageInfo: "Veuillez actualiser la page, car le nombre de jours demandé ne peut pas être négatif" });
    } else {
       if (!dateBeginFormatNotMatch && !dateEndFormatNotMatch &&
          !dateBeginInDayNotCounted && !dateEndinDayNotCounted) {
          if (!valid && !validdebut) {
            if (valide === "valide") {
              if (isCancel && askedDayOff === 0) {
                setConfirmationDialog({ ...confirmationDialog, openDialog: true });
              } else {
                handleChangeLeave(0);
              }
            } else {
              const today = new Date();
              const targetDate = new Date('2024-12-30');
              if(parseInt(askedDayOff,10) > 5 ) {
                setOpenDialoguejourmax(true);
              } else {
                if (isLeavePlanningUpdated) {
                  handleChangeLeave(0);
                } else {
                  setConfirmLeaveAdd(true);
                  setConfirmationDialog({ ...confirmationDialog, openDialog: true });
                }
              }
            }
          }
        }
    }
  }

  const classes = useStyles();

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  function handleBeginDateChange(e) {
    const formattedDate = e.target.value;
    const debutDate = moment(formattedDate).format("YYYY-MM-DD"); 

    setBeginDate(debutDate);
    Daynumber(formattedDate, endDate, radioBeginDate, radioEndDate);
    
    if (checkIfDateInDayNotCompted(debutDate)) {
      setDateBeginInDayNotCounted(true);
      setBeginDate(debutDate);
    } else {
      setDateBeginInDayNotCounted(false);
      setBeginDateNotMatch(false);
      setDateBeginFormatNotMatch(false);
      
      if (isValidDate(formattedDate)) {
        if (moment(formattedDate).year() < 999) {
          setDateBeginFormatNotMatch(true);
        } else {
          if (endDate !== "" && endDate !== undefined && (debutDate < endDate)) {
            setValiddebut(false);
            setValid(false);
            const debutDateYear = new Date(formattedDate).getFullYear();
            const endDateYear = new Date(endDate).getFullYear();
            
            if (debutDateYear === endDateYear) {
              setBeginDateNotMatch(false);
              if (valide === "valide") {
                if (beginDate === debutDate) {
                  setBeginDate(debutDate);
                  Daynumber(beginDate, endDate, radioBeginDate, radioEndDate);
                  setLeaveValide(0);
                  setIsValidEdited(false);
                } else {
                  Daynumber(debutDate, endDate, radioBeginDate, radioEndDate);
                  setBeginDate(debutDate);
                  setLeaveValide(1);
                  setIsValidEdited(true);
                }
              } else {
                if (endDate !== "") {
                  Daynumber(debutDate, endDate, radioBeginDate, radioEndDate);
                }
                setBeginDate(debutDate);
              }
            } else if (debutDateYear !== endDateYear && debutDateYear.toString().length === 4) {
              setBeginDateNotMatch(true);
            }
          } else if (endDate !== "" && endDate !== undefined && (debutDate > endDate)) {
            setValiddebut(true);
          } else if (valide === "valide" && endDate !== "" && endDate !== undefined && debutDate == endDate) {
            if (radioBeginDate === radioEndDate) {
              setIsCancel(true);
              setValid(false);
              setBeginDate(debutDate);
              Daynumber(debutDate, endDate, radioBeginDate, radioEndDate);
              setIsValidEdited(false);
            } else {
              Daynumber(debutDate, endDate, radioBeginDate, radioEndDate);
              setBeginDate(debutDate);
              setLeaveValide(1);
              setIsValidEdited(true);
            }
          } else {
            setBeginDate(debutDate);
          }
        }
      }
    }
  }

  function handleEndDateChange(e) {
    const formatDte = e.target.value;
    const datefin = moment(formatDte).format("YYYY-MM-DD");
    setEndDate(datefin);
    Daynumber(beginDate, formatDte, radioBeginDate, radioEndDate);
    
    if (checkIfDateInDayNotCompted(datefin)) {
      setEndDate(datefin);
      setDateEndinDayNotCounted(true);
    } else {
      setDateEndinDayNotCounted(false);
      setDateEndFormatNotMatch(false);
      
      if (isValidDate(formatDte)) {
        if (moment(formatDte).year() < 999) {
          setDateEndFormatNotMatch(true);
        } else {
          if (beginDate !== "" && beginDate !== undefined && (beginDate < datefin)) {
            setValid(false);
            setValiddebut(false);
            if (valide === "valide") {
              if (endDate === datefin) {
                Daynumber(beginDate, datefin, radioBeginDate, radioEndDate);
                setEndDate(datefin);
                setLeaveValide(0);
                setIsValidEdited(false);
              } else {
                Daynumber(beginDate, datefin, radioBeginDate, radioEndDate);
                setEndDate(datefin);
                setLeaveValide(1);
                setIsValidEdited(true);
              }
            } else {
              if (beginDate !== "") {
                Daynumber(beginDate, datefin, radioBeginDate, radioEndDate);
              }
              setEndDate(datefin);
            }
          } else if (beginDate !== "" && beginDate !== undefined && beginDate > datefin) {
            setValid(true);
          } else if (valide === "valide" && beginDate !== "" && beginDate !== undefined && beginDate == datefin) {
            if (radioBeginDate === radioEndDate) {
              setIsCancel(true);
              setValid(false);
              setEndDate(datefin);
              Daynumber(beginDate, datefin, radioBeginDate, radioEndDate);
              setIsValidEdited(false);
            } else {
              Daynumber(beginDate, datefin, radioBeginDate, radioEndDate);
              setEndDate(datefin);
              setLeaveValide(1);
              setIsValidEdited(true);
            }
          } else {
            setEndDate(datefin);
          }
        }
      }
    }
  }


  useEffect(() => {
    localStorage.setItem('status', 0);
    
    setRadioBeginDate("morning");
    setRadioEndDate("morning");

    const propsInitialBalance = localStorage.getItem("isInitialBalanceConfigurated");

    if (propsInitialBalance !== null && propsInitialBalance !== undefined && propsInitialBalance.trim().length !== 0) {
      setisRealBalanceAlreadyConfigurate(propsInitialBalance);
    }

    LeaveService.pendingleave().then((result) => {
      setPendingleave(result.data);
    });

    const propsActualBalance = localStorage.getItem("realBefore");

    if (propsActualBalance !== null && propsActualBalance !== undefined && propsActualBalance.trim().length !== 0) {
      setRealdelta(propsActualBalance);
    }

    DayService.getDay().then((results) => {
      if (results && results.data) {
        setDay(results.data);
      }
    });
    
    LeaveService.getLeaveType().then((result) => {
      if (result && result.data) {
        setLeaveType(
          result.data.map((d) => {
            return { id: d.leave_type_id, label: d.name, desc: d.desc };
          })
        );
      }
    });
    
    if (idLeaveToUpdated) {
      setIdLeave(idLeaveToUpdated)
      setLeaveUpdated(true);
    }
    
    if (valide === "valide") {
      setIsConfirmationFinal(true);
      setIdLeave(idLeaveToValidate);
      if (leaveValide !== 1) {
        // setIsvalid(1);
      } else if (leaveValide === 1) {
        // setFile(null);
      }
    }

    if (valide === "editPlanning") {
      setIdLeave(idLeaveToValidate);
      setidLeavePlanningUpdated(idLeaveToValidate);
      setisLeavePlanningUpdated(true);
    }

    UserService.checkValidatornumberByUserId(0).then((results) => {
      if (results && results.status) {
        setisValidatorNumberConfigurate(true);
        setdayOffNumberWithoutValidation(results.data.user_validator_number_dayNumberWithoutValidation);
      }
    });
  }, [location]);

  useEffect(() => {
    if (isRealBalanceAlreadyConfigurate) {
      DayService.getDay().then((results) => {
        if (results && results.data) {
          setDay(results.data);
        }
      });
    }
  }, [isRealBalanceAlreadyConfigurate]);

  useEffect(() => {
    if (isLeaveUpdated || idLeavePlanningUpdated) {
      const propsInitialBalance = localStorage.getItem("isInitialBalanceConfigurated");

      if (propsInitialBalance !== null && propsInitialBalance !== undefined && propsInitialBalance.trim().length !== 0) {
        setisRealBalanceAlreadyConfigurate(propsInitialBalance);
      }

      const propsActualBalance = localStorage.getItem("realBefore");

      if (propsActualBalance !== null && propsActualBalance !== undefined && propsActualBalance.trim().length !== 0) {
        setRealdelta(propsActualBalance);
      }

      LeaveService.getLeaveType().then((result) => {
        if (result && result.data) {
          setLeaveType(
            result.data.map((d) => {
              return { id: d.leave_type_id, label: d.name, desc: d.desc };
            })
          );
        }
      });

      LeaveService.getLeaveById(idLeave).then((info) => {
        // setIsvalid(0);
        // setFile(info.data.file);
        setDayOffType(info.data.leave_type_id);
        setMotif(info.data.reason);
        setRadioBeginDate(info.data.begin_time_session);
        setRadioEndDate(info.data.end_time_session);
        setAskedDayOff(info.data.duration);
        
        const results = info.data.begin_time;
        const date = results.split(' ');
        const fin = info.data.end_time;
        const findate = fin.split(' ');
        
        setBeginDate(date[0]);
        setEndDate(findate[0]);
        setOpenLoadingSimpleBackdrop(false);
      });
    }
  }, [isLeaveUpdated, isLeavePlanningUpdated]);

  useEffect(() => {
    if (isConfirmationFinal) {
      setOpenLoadingSimpleBackdrop(true);

      const propsInitialBalance = localStorage.getItem("isInitialBalanceConfigurated");

      if (propsInitialBalance !== null && propsInitialBalance !== undefined && propsInitialBalance.trim().length !== 0) {
        setisRealBalanceAlreadyConfigurate(propsInitialBalance);
      }

      const propsActualBalance = localStorage.getItem("realBefore");

      if (propsActualBalance !== null && propsActualBalance !== undefined && propsActualBalance.trim().length !== 0) {
        setRealdelta(propsActualBalance);
      }

      LeaveService.getLeaveType().then((result) => {
        if (result && result.data) {
          setLeaveType(
            result.data.map((d) => {
              return { id: d.leave_type_id, label: d.name, desc: d.desc };
            })
          );
        }
      });

      LeaveService.getLeaveById(idLeaveToValidate).then((info) => {
        // setFile(info.data.file);
        setDayOffType(info.data.leave_type_id);
        setMotif(info.data.reason);
        setRadioBeginDate(info.data.begin_time_session);
        setRadioEndDate(info.data.end_time_session);
        setAskedDayOff(info.data.duration);
        
        const results = info.data.begin_time;
        const date = results.split(' ');
        const fin = info.data.end_time;
        const findate = fin.split(' ');
        
        setBeginDate(date[0]);
        setEndDate(findate[0]);
        setAskedDayOff(info.data.duration);
        setCodeLeave(info.data.leave_code);
        setFileRequest(info.data.file);
        setOpenLoadingSimpleBackdrop(false);
      });
    }
  }, [isConfirmationFinal]);

  const handleRadioChange = (name) => (event) => {
    if (name === "begin") {
      if (valide === "valide") {
        if (radioBeginDate === event.target.value) {
          Daynumber(beginDate, endDate, event.target.value, radioEndDate);
          setRadioBeginDate(event.target.value);
          setLeaveValide(0);
        } else {
          Daynumber(beginDate, endDate, event.target.value, radioEndDate);
          setRadioBeginDate(event.target.value);
          setLeaveValide(1);
          setIsValidEdited(true);
        }
      } else {
        if (endDate !== undefined) {
          Daynumber(beginDate, endDate, event.target.value, radioEndDate);
        }
        setRadioBeginDate(event.target.value);
      }
    } else {
      if (valide === "valide") {
        if (radioEndDate === event.target.value) {
          Daynumber(beginDate, endDate, radioBeginDate, event.target.value);
          setRadioEndDate(event.target.value);
          setLeaveValide(0);
        } else {
          Daynumber(beginDate, endDate, radioBeginDate, event.target.value);
          setRadioEndDate(event.target.value);
          setLeaveValide(1);
          setIsValidEdited(true);
        }
      } else {
        setRadioEndDate(event.target.value);
        if (endDate !== undefined) {
          Daynumber(beginDate, endDate, radioBeginDate, event.target.value);
        }
      }
    }
  };



  function handleCancel() {
    navigate("/leavestglist");
  }

 
  const handleValidCancel = () => {
    setLoading(true);
    setEmptyMotif(false);
    if (raison && raison.trim().length !== 0 && raison !== undefined) {
      LeaveService.getLeaveObselete(raison, codeobselete, fileObselete, idLeaveToValidate).then((result) => {
        if (result !== "") {
          if (result.status) {
            setCancel(false);
            setRaison("");
            setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.data.message });
            setEmptyMotif(false);
            navigate("/me/leaves");
          } else {
            setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
          }
        } else {
          setMessage({ ...message, openMessage: true, color: 'red', messageInfo: "Une erreur s'est produite. Veuillez réessayer" });
        }
      }).catch((err) => {
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'erreur' });
      });
    } else {
      setEmptyMotif(true);
      setLoading(false);
    }
  };

  const handleCloseCancel = (event, reason) => {
    if (reason === "backdropClick") {
      return false;
    }
    setCancel(false);
  };

  function handleRaison(ev) {
    setRaison(ev.target.value);
    setEmptyMotif(false);
  }

  function checkIfDateInDayNotCompted(date) {
    if (day.includes(date)) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <MainContainer {...headerDataRH}>
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />

      <MotifAnnulationLeave openDialog={cancel} handleCloseCancel={handleCloseCancel} raison={raison}
        handleRaison={handleRaison} emptyMotif={emptyMotif} isLoading={isLoading} handleValidCancel={handleValidCancel} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Paper className={classes.paper} variant="outlined">
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <label>Date de départ{bullRed}</label>
            </Grid>
            <Grid item xs={8}>
              <TextField
                label="Date de départ"
                type="date"  
                value={beginDate || ''} 
                onChange={handleBeginDateChange}
                fullWidth
                variant="outlined"
                size="small"
                color="primary"
                error={validdebut} 
                InputLabelProps={{
                  shrink: true, 
                }}
              />
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="position"
                  name="position"
                  defaultValue="top"
                  value={radioBeginDate}
                  onChange={handleRadioChange("begin")}
                >
                  <FormControlLabel
                    value="morning"
                    control={<Radio color="primary" />}
                    label="Matin"
                  />
                  <FormControlLabel
                    value="afternoon"
                    control={<Radio color="primary" />}
                    label="Après-midi"
                  />
                </RadioGroup>
              </FormControl>
              {validdebut && <Alert severity="error">La date de départ doit être inférieur à la date de retour</Alert>}
              {beginDateNotMatch && <Alert severity="error">L'année de votre départ n'est pas conforme à celle du retour. Veuillez vérifier!</Alert>}
              {dateBeginFormatNotMatch && <Alert severity="warning">La norme demandée pour la date c'est JJ/MM/AAAA). Veuillez vérifier!</Alert>}
              {dateBeginInDayNotCounted && <Alert severity="warning">Votre date de départ est un jour férié ou weekend. Veuillez vérifier!</Alert>}
            </Grid>
            <Grid item xs={4}>
              <label>Date de retour{bullRed}</label>
            </Grid>
            <Grid item xs={8}>
              <TextField
                label="Date de retour"
                type="date"  
                value={endDate || ''} 
                onChange={handleEndDateChange}
                fullWidth
                variant="outlined"
                size="small"
                color="primary"
                InputLabelProps={{
                  shrink: true, 
                }}
              />
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="position"
                  name="position"
                  defaultValue="top"
                  value={radioEndDate}
                  onChange={handleRadioChange("end")}
                >
                  <FormControlLabel
                    value="morning"
                    control={<Radio color="primary" />}
                    label="Matin"
                  />
                  <FormControlLabel
                    value="afternoon"
                    control={<Radio color="primary" />}
                    label="Après-midi"
                  />
                </RadioGroup>
              </FormControl>
              {valid && <Alert severity="error">La date de retour doit être superieur à la date de départ</Alert>}
              {dateEndFormatNotMatch && <Alert severity="warning">La norme demandée pour la date c'est JJ/MM/AAAA). Veuillez vérifier!</Alert>}
              {dateEndinDayNotCounted && <Alert severity="warning">Votre date de retour est un jour férié ou weekend. Veuillez vérifier!</Alert>}
            </Grid>

            <Grid item xs={4}>
              <label>Nombre de jour demandé</label>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={askedDayOff}
                name="duration"
                readOnly={true}
                disabled={true}
                className={classes.disabledSolde}
              />
            </Grid>

            {valide === "valide" && (
              <>
                <Spacer y={2} />
                <Grid container item xs={12} direction="row-reverse">
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "grey" }}
                    onClick={handleCancel}
                  >
                    ANNULER
                  </Button>
                  <Spacer x={2} />
                  {hasPrivilege(contextData.privileges, 'Admin-Button-Save-Leave') &&
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleClick}
                      style={{ fontWeight: 600 }}
                    >
                     {isLoading ? (
                        <>
                          <CircularProgress size={20} /> Chargement...
                        </>
                      ) : (
                        "CONFIRMER"
                      )}
                    </Button>
                  }
                </Grid>
              </>
            )}
            {valide !== "valide" && (
              <>
                <Spacer y={2} />
                <Grid item xs={12}>
                  <label className={classes.text}>({bullRed}):Champs obligatoires</label>
                </Grid>
                {!isRealBalanceAlreadyConfigurate &&
                  <Alert severity="warning">{errorMessageForRealBalanceEmpty}</Alert>
                }
                <Spacer y={2} />
                <Grid container item xs={12} direction="row-reverse">
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "grey" }}
                    onClick={handleCancel}
                  >
                    ANNULER
                  </Button>
                   <Spacer x={2} />
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleChangeLeave(1)}
                      disabled={(!isRealBalanceAlreadyConfigurate || dateBeginInDayNotCounted || dateBeginFormatNotMatch || dateEndFormatNotMatch || dateEndinDayNotCounted) ? true : false}
                      style={{ fontWeight: 600 }}
                    >
                    {isLoading ? (
                    <>
                        <CircularProgress size={20} color="inherit" />
                        Chargement...
                    </>
                    ) : (
                    "ENVOYER POUR VALIDATION"
                    )}
                    </Button>
                </Grid>
              </>
            )}
          </Grid>
        </Paper>
      </MuiPickersUtilsProvider>
      <>
        <BootstrapDialog
          onClose={handleCloseJourmax}
          aria-labelledby="customized-dialog-title"
          open={openDialoguejoursmax}
        >
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            Nombre de jours de congé non autorisé
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseJourmax}
            sx={(theme) => ({
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent dividers>
            <Typography gutterBottom>
              Vous ne pouvez demander des congés que pour une durée maximale de 5 jours.
            </Typography>
            <Typography gutterBottom>
              Veuillez ajuster votre demande en conséquence.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCloseJourmax}>
              D'accord, compris
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </>
    </MainContainer>
  );
}

export default LeaveStagiaire;